module.exports = __webpack_public_path__ + "img/ug.a25af5b7.svg";